
$(document).ready(function(){
  $('.t-head-outer:nth-child(1)').addClass('active');
  $('.t-head-outer').on('click', function(){
    var tab_id = $(this).attr('data-tab-id');
     $('.t-head-outer').each(function(){
       $(this).removeClass('active');
       console.log("remove");
     });
   $(this).addClass('active');
     console.log("add"); 
    $('.content-main-wrp-block-heading').each(function(){
        var tb_cont=$(this).attr('data-content-id');
        if(tb_cont==tab_id){
          $(this).show();
        }
      else{
        $(this).hide();
      }
    })
     
  });

   

});

